import { render, staticRenderFns } from "./CaregiverDashboard.vue?vue&type=template&id=ef758cc4&scoped=true"
import script from "./CaregiverDashboard.vue?vue&type=script&lang=js"
export * from "./CaregiverDashboard.vue?vue&type=script&lang=js"
import style0 from "./CaregiverDashboard.vue?vue&type=style&index=0&id=ef758cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef758cc4",
  null
  
)

export default component.exports